import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem("tali_client_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Get public pricing information (no auth required)
 */
export const getMembershipPricing = async () => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/pricing`);
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Apply for membership. Accepts FormData (with photo files) or a plain object.
 * Axios sets the multipart boundary automatically when given FormData.
 */
export const applyForMembership = async (applicationData) => {
  try {
    const response = await axios.post(
      `${BASE_API}/memberships/apply`,
      applicationData,
      { headers: getAuthHeaders() }
    );
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get user's membership status
 */
export const getMyMembershipStatus = async () => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/my-status`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get membership details
 */
export const getMembershipDetails = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Initialize payment for approved membership
 */
export const initializeMembershipPayment = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/${id}/payment`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Check payment status
 */
export const getPaymentStatus = async (purchaseId) => {
  try {
    const response = await axios.get(`${BASE_API}/memberships/payment/${purchaseId}/status`, {
      headers: getAuthHeaders(),
    });
    return response.data.data || response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Download wallet card (PDF)
 */
export const downloadWalletCard = async (membershipId) => {
  try {
    const response = await axios.get(
      `${BASE_API}/memberships/${membershipId}/wallet-card`,
      {
        headers: getAuthHeaders(),
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Download QR code (PNG)
 */
export const downloadQRCode = async (membershipId) => {
  try {
    const response = await axios.get(
      `${BASE_API}/memberships/${membershipId}/qr-code`,
      {
        headers: getAuthHeaders(),
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Download Apple Wallet pass (.pkpass)
 */
export const downloadAppleWalletPass = async (membershipId) => {
  try {
    const response = await axios.get(
      `${BASE_API}/memberships/${membershipId}/apple-wallet`,
      {
        headers: getAuthHeaders(),
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
